import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import Layout from "./components/layout/Layout";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import Home from "./pages/otherPages/Home";
import Register from "./pages/auth/Register";
import axios from "axios";
import Products from "./pages/otherPages/Products";
import AddProduct from "./pages/otherPages/AddProduct";
import AddCategories from "./pages/otherPages/AddCategories";
import AddBrand from "./pages/otherPages/AddBrand";
import Orders from "./pages/otherPages/Orders";
import EditProduct from "./pages/otherPages/EditProduct";
import Customers from "./pages/otherPages/Customers";
import Notifyme from "./pages/otherPages/Notifyme";

//axios.defaults.baseURL = process.env.REACT_APP_AXIOS_LINK;
//axios.defaults.baseURL = "http://localhost:6021/api/v1";
axios.defaults.baseURL = "https://api.notionsgroup.com/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<LoginPage />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/customer" element={<Customers />} />
          <Route path="/add-products" element={<AddProduct />} />
          <Route path="/categories" element={<AddCategories />} />
          <Route path="/brands" element={<AddBrand />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/notifyme" element={<Notifyme />} />
          <Route path="/update-product" element={<EditProduct />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
